<template>
  <!-- XSTUDI contact text (SystemConfig.contactInfo, same text as under the
       login button). Nothing renders until the text is loaded and non-empty. -->
  <div v-if="text" class="navbar-contact-info flex items-center">

    <!-- md and up (>= 768px): phone icon + full text -->
    <div class="navbar-contact-info__inline hidden md:flex items-center" :title="text">
      <feather-icon icon="PhoneIcon" svgClasses="h-5 w-5" class="text-primary mr-2" />
      <span class="navbar-contact-info__text text-xs">{{ text }}</span>
    </div>

    <!-- below md (< 768px): phone icon only, tap to open the full text -->
    <vs-dropdown class="md:hidden cursor-pointer" vs-custom-content vs-trigger-click>
      <feather-icon icon="PhoneIcon" svgClasses="h-6 w-6" class="text-primary mt-1 mr-2" />
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <div class="navbar-contact-info__text navbar-contact-info__popover text-sm p-4">{{ text }}</div>
      </vs-dropdown-menu>
    </vs-dropdown>

  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';

  // SystemConfig is registered statically in src/store/index.js, so it is
  // always there on Main-layout pages (Login.vue's lowercase `systemConfig`
  // copy only exists after visiting the login page).
  const {mapState, mapActions} = createNamespacedHelpers('SystemConfig');

  export default {
    name: 'contact-info',
    computed: {
      ...mapState(['contactInfo']),
      text() {
        return typeof this.contactInfo === 'string' ? this.contactInfo.trim() : '';
      },
    },
    methods: {
      ...mapActions(['loadContactInfo']),
    },
    mounted() {
      // The action already swallows its own errors; this catch is a second
      // guard so a failed load can never surface as an unhandled rejection.
      Promise.resolve(this.loadContactInfo()).catch(() => {});
    },
  }
</script>

<style scoped>
  .navbar-contact-info__text {
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.25;
  }

  /* keep the inline block inside the navbar: three lines at most, the full
     text is still in the title tooltip */
  .navbar-contact-info__inline .navbar-contact-info__text {
    display: block;
    max-height: 3.75em;
    overflow: hidden;
  }

  /* fixed width: vs-dropdown measures the menu before the text wraps, so a
     width driven by the text makes it place the menu off the right edge */
  .navbar-contact-info__popover {
    width: 16rem;
    max-width: calc(100vw - 2rem);
  }
</style>
